import { Injectable } from '@angular/core';

interface Avatar {
  background: string;
  color: string;
}

@Injectable()
export class AvatarService {
  colorValues = [
    {
      background: '#ffebee',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffcdd2',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ef9a9a',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e57373',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ef5350',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f44336',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e53935',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#d32f2f',
      color: 'white',
    },
    {
      background: '#c62828',
      color: 'white',
    },
    {
      background: '#b71c1c',
      color: 'white',
    },
    {
      background: '#ff8a80',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff5252',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff1744',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#d50000',
      color: 'white',
    },
    {
      background: '#fce4ec',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f8bbd0',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f48fb1',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f06292',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ec407a',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e91e63',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#d81b60',
      color: 'white',
    },
    {
      background: '#c2185b',
      color: 'white',
    },
    {
      background: '#ad1457',
      color: 'white',
    },
    {
      background: '#880e4f',
      color: 'white',
    },
    {
      background: '#ff80ab',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff4081',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f50057',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#c51162',
      color: 'white',
    },
    {
      background: '#f3e5f5',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e1bee7',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ce93d8',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ba68c8',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ab47bc',
      color: 'white',
    },
    {
      background: '#9c27b0',
      color: 'white',
    },
    {
      background: '#8e24aa',
      color: 'white',
    },
    {
      background: '#7b1fa2',
      color: 'white',
    },
    {
      background: '#6a1b9a',
      color: 'white',
    },
    {
      background: '#4a148c',
      color: 'white',
    },
    {
      background: '#ea80fc',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e040fb',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#d500f9',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#aa00ff',
      color: 'white',
    },
    {
      background: '#ede7f6',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#d1c4e9',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#b39ddb',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#9575cd',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#7e57c2',
      color: 'white',
    },
    {
      background: '#673ab7',
      color: 'white',
    },
    {
      background: '#5e35b1',
      color: 'white',
    },
    {
      background: '#512da8',
      color: 'white',
    },
    {
      background: '#4527a0',
      color: 'white',
    },
    {
      background: '#311b92',
      color: 'white',
    },
    {
      background: '#b388ff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#7c4dff',
      color: 'white',
    },
    {
      background: '#651fff',
      color: 'white',
    },
    {
      background: '#6200ea',
      color: 'white',
    },
    {
      background: '#e8eaf6',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#c5cae9',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#9fa8da',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#7986cb',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#5c6bc0',
      color: 'white',
    },
    {
      background: '#3f51b5',
      color: 'white',
    },
    {
      background: '#3949ab',
      color: 'white',
    },
    {
      background: '#303f9f',
      color: 'white',
    },
    {
      background: '#283593',
      color: 'white',
    },
    {
      background: '#1a237e',
      color: 'white',
    },
    {
      background: '#8c9eff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#536dfe',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#3d5afe',
      color: 'white',
    },
    {
      background: '#304ffe',
      color: 'white',
    },
    {
      background: '#e3f2fd',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#bbdefb',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#90caf9',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#64b5f6',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#42a5f5',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#2196f3',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#1e88e5',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#1976d2',
      color: 'white',
    },
    {
      background: '#1565c0',
      color: 'white',
    },
    {
      background: '#0d47a1',
      color: 'white',
    },
    {
      background: '#82b1ff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#448aff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#2979ff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#2962ff',
      color: 'white',
    },
    {
      background: '#e1f5fe',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#b3e5fc',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#81d4fa',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#4fc3f7',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#29b6f6',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#03a9f4',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#039be5',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#0288d1',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#0277bd',
      color: 'white',
    },
    {
      background: '#01579b',
      color: 'white',
    },
    {
      background: '#80d8ff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#40c4ff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00b0ff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#0091ea',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e0f7fa',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#b2ebf2',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#80deea',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#4dd0e1',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#26c6da',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00bcd4',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00acc1',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#0097a7',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00838f',
      color: 'white',
    },
    {
      background: '#006064',
      color: 'white',
    },
    {
      background: '#84ffff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#18ffff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00e5ff',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00b8d4',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e0f2f1',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#b2dfdb',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#80cbc4',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#4db6ac',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#26a69a',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#009688',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00897b',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00796b',
      color: 'white',
    },
    {
      background: '#00695c',
      color: 'white',
    },
    {
      background: '#004d40',
      color: 'white',
    },
    {
      background: '#a7ffeb',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#64ffda',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#1de9b6',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00bfa5',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e8f5e9',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#c8e6c9',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#a5d6a7',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#81c784',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#66bb6a',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#4caf50',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#43a047',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#388e3c',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#2e7d32',
      color: 'white',
    },
    {
      background: '#1b5e20',
      color: 'white',
    },
    {
      background: '#b9f6ca',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#69f0ae',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00e676',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#00c853',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f1f8e9',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#dcedc8',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#c5e1a5',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#aed581',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#9ccc65',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#8bc34a',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#7cb342',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#689f38',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#558b2f',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#33691e',
      color: 'white',
    },
    {
      background: '#ccff90',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#b2ff59',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#76ff03',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#64dd17',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f9fbe7',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f0f4c3',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e6ee9c',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#dce775',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#d4e157',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#cddc39',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#c0ca33',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#afb42b',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#9e9d24',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#827717',
      color: 'white',
    },
    {
      background: '#f4ff81',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#eeff41',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#c6ff00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#aeea00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fffde7',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fff9c4',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fff59d',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fff176',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffee58',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffeb3b',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fdd835',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fbc02d',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f9a825',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f57f17',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffff8d',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: 'yellow',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffea00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffd600',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fff8e1',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffecb3',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffe082',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffd54f',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffca28',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffc107',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffb300',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffa000',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff8f00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff6f00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffe57f',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffd740',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffc400',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffab00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fff3e0',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffe0b2',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffcc80',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffb74d',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffa726',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff9800',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fb8c00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f57c00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ef6c00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e65100',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffd180',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffab40',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff9100',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff6d00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#fbe9e7',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffccbc',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ffab91',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff8a65',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff7043',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff5722',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#f4511e',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e64a19',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#d84315',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#bf360c',
      color: 'white',
    },
    {
      background: '#ff9e80',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff6e40',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#ff3d00',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#dd2c00',
      color: 'white',
    },
    {
      background: '#efebe9',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#d7ccc8',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#bcaaa4',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#a1887f',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#8d6e63',
      color: 'white',
    },
    {
      background: '#795548',
      color: 'white',
    },
    {
      background: '#6d4c41',
      color: 'white',
    },
    {
      background: '#5d4037',
      color: 'white',
    },
    {
      background: '#4e342e',
      color: 'white',
    },
    {
      background: '#3e2723',
      color: 'white',
    },
    {
      background: '#fafafa',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: 'whitesmoke',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#eeeeee',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#e0e0e0',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#bdbdbd',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#9e9e9e',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#757575',
      color: 'white',
    },
    {
      background: '#616161',
      color: 'white',
    },
    {
      background: '#424242',
      color: 'white',
    },
    {
      background: '#212121',
      color: 'white',
    },
    {
      background: '#eceff1',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#cfd8dc',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#b0bec5',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#90a4ae',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#78909c',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#607d8b',
      color: 'rgba(0, 0, 0, 0.87)',
    },
    {
      background: '#546e7a',
      color: 'white',
    },
    {
      background: '#455a64',
      color: 'white',
    },
    {
      background: '#37474f',
      color: 'white',
    },
    {
      background: '#263238',
      color: 'white',
    },
  ];

  getColor(userName: string): Avatar {
    const filteredColorValues = this.colorValues.filter(colorValue => colorValue.color === 'white');
    const materialIndex = Array.from(userName).map(character => character.charCodeAt(0)).reduce((a, c) => a + c) % filteredColorValues.length;
    return filteredColorValues[materialIndex];
  }
}
